import { useEffect } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { kindeAuthOptions } from '../config/kinde';
import styles from './AuthSuccessPage.module.css';

export default function LoginPage() {
  const { login, isLoading, isAuthenticated } = useKindeAuth();

  useEffect(() => {
    // If already authenticated, redirect to success page
    if (isAuthenticated) {
      window.location.href = '/auth/success';
      return;
    }

    // If not authenticated and not loading, trigger login
    if (!isLoading) {
      login(kindeAuthOptions);
    }
  }, [login, isLoading, isAuthenticated]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.spinner}></div>
        <h1>Redirecting to login...</h1>
        <p>Please wait while we redirect you to the authentication page.</p>
      </div>
    </div>
  );
}
